import { createStore } from 'satcheljs';
import type { AccountSourceList } from './schema/AccountSourceList';
import { LoadState } from './schema/AccountSourceList';

export const defaultStore: AccountSourceList = {
    loadState: LoadState.Loading,
    selectedSourceId: '',
    globalSettingsSourceId: '',
    sources: [],
    identities: [],
};

const store = createStore<AccountSourceList>('AccountSourceList', defaultStore)();
export default () => store;
